import { useEffect, useState } from 'react';
import { useMedia } from 'react-use';

const useResponsiveTitle = () => {
  const isMobile = useMedia('(max-width: 767px)');
  const [titleClass, setTitleClass] = useState<'text-display_3' | 'text-display_2'>('text-display_2');

  useEffect(() => {
    setTitleClass(isMobile ? 'text-display_3' : 'text-display_2');
  }, [isMobile]);

  return titleClass;
};

export default useResponsiveTitle;
